/* eslint-disable */
function init() {

    const toggleFooterOpen = (element) => {
        const parent = $(element).closest('.boggi_footer_links');
        parent.toggleClass('open');
    };

    $('.boggi_footer_links').on('click', function () {
        toggleFooterOpen(this);
    });

    $('.boggi_footer_links a').on('click', function (e) {
		dataLayer.push({
			'event': 'custom_event',
			'eventCategory': 'footer_navigation',
			'eventAction': 'footer_navigation_click',
			'eventLabel': $(this).text(),
			'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
			'screenName': 'Footer navigation',
			'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
			'userId': user.user_id != '' ? user.user_id : ''
		});
	});

    $('.social-links a').on('click', function (e) {
		dataLayer.push({
			'event': 'custom_event',
			'eventCategory': 'footer_navigation',
			'eventAction': 'footer_navigation_social_icon',
			'eventLabel': $(this).data('sharing-option'),
			'country': window.GlobalAttributes.COUNTRY || window.GlobalAttributes.country,
            'language': window.GlobalAttributes.LANGUAGE || window.GlobalAttributes.language,
			'screenName': 'Footer navigation',
			'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
			'userId': user.user_id != '' ? user.user_id : ''
		});
	})

}

module.exports = {
    init: init
};



// WEBPACK FOOTER //
// ./cartridges/app_boggi_core/cartridge/js/sections/footer/footer.js